import { usePaywallCheckoutAttemptsContextOrNull } from "../../Attempts/PaywallCheckoutAttemptsContext";
import { usePayment } from "../../hooks/usePayment";

export const useCheckoutSubmit = () => {
  const { isSubmitDisabled } = usePayment();
  const attemptsContext = usePaywallCheckoutAttemptsContextOrNull();

  if (!attemptsContext) {
    throw new Error(
      "useCheckoutSubmit: PaywallCheckoutAttemptsProvider not found",
    );
  }

  return { submit: attemptsContext.submitAttempt, isSubmitDisabled };
};
